<template>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoading">
            <slot name="content" :listData="listData"/>
        </van-list>
    </van-pull-refresh>
</template>

<script>
    export default {
        name: 'list-view',
        props: {
            size: {
                type: Number,
                default: 10
            },
            attr: {
                type: Object,
                default: () => {
                    return {
                        current: 'current', // 响应当前页数
                        size: 'size', // 响应每页显示多少条,
                        pages: 'pages', // 响应总页数
                        total: 'total', // 响应总数
                        records: 'records' // 响应数据
                    }
                }
            }
        },
        data() {
            return {
                loading: false,
                finished: false,
                refreshing: false,
                page: {
                    total: 0, // 总数
                    pages: 0, // 总页数
                    current: 0, // 当前页数
                    size: 10 // 每页显示多少条
                },
                listData: []
            }
        },
        methods: {
            onRefresh() {
                // 初始化分页
                this.page.current = 0;
                this.page.size = this.size;
                // 初始化刷新
                this.refreshing = true;
                // 清空列表数据
                this.finished = true;
                // 将 loading 设置为 false
                this.loading = false;
                // 重新加载数据
                this.onLoading();
            },
            onLoading() {
                const data = {
                    current: this.page.current + 1,
                    size: this.page.size
                };
                // 添加加载回调
                this.$emit('request', data, this.page);
            },
            onSuccess(data) {
                if (data) {
                    // 关闭加载
                    this.loading = false;
                    // 关闭刷新
                    this.refreshing = false;

                    // 分页数据赋值
                    this.page.current = data[this.attr.current];
                    this.page.size = data[this.attr.size];
                    this.page.pages = data[this.attr.pages];
                    this.page.total = data[this.attr.total];

                    // 分页数据验证
                    if (this.page.current === undefined || this.page.current === null) {
                        this.page.current = 1;
                    }
                    if (this.page.size === undefined || this.page.size === null) {
                        this.page.size = this.size;
                    }
                    if (this.page.pages === undefined || this.page.pages === null) {
                        this.page.pages = 0;
                    }
                    if (this.page.total === undefined || this.page.total === null) {
                        this.page.total = 0;
                    }

                    // 判断是否完结
                    this.finished = this.page.current >= this.page.pages;

                    // 业务数据赋值
                    const records = data[this.attr.records] || [];
                    if (this.page.current <= 1) {
                        this.listData = records;
                    } else {
                        this.listData = this.listData.concat(records);
                    }
                }
            },
            onFailure() {
                // 关闭加载
                this.loading = false;
                // 关闭刷新
                this.refreshing = false;
                // 判断是否完结
                this.finished = this.page.current >= this.page.pages;
                // 初始化数据
                if (this.refreshing) {
                    this.listData = [];
                }
            },
            onNextSuccess(data) {
                if (data) {
                    // 关闭加载
                    this.loading = false;
                    // 关闭刷新
                    this.refreshing = false;

                    // 分页数据赋值
                    this.page.total = data[this.attr.total];

                    // 分页数据验证
                    this.page.current = this.page.current + 1;
                    if (this.page.total === undefined || this.page.total === null) {
                        this.page.total = 0;
                    }

                    // 判断是否完结
                    this.finished = this.page.current * this.page.size >= this.page.total;

                    // 业务数据赋值
                    const records = data[this.attr.records] || [];
                    if (this.page.current <= 1) {
                        this.listData = records;
                    } else {
                        this.listData = this.listData.concat(records);
                    }
                }
            },
            onNextFailure() {
                // 关闭加载
                this.loading = false;
                // 关闭刷新
                this.refreshing = false;
                // 判断是否完结
                this.finished = this.page.current * this.page.size >= this.page.total;
                // 初始化数据
                if (this.refreshing) {
                    this.listData = [];
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .van-pull-refresh {
        overflow-y: auto;
        height: 100%;
    }
</style>
